module.exports = __webpack_public_path__ + "static/img/9.85f93d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/9.png
// module id = C9QG
// module chunks = 4